import React, { useEffect } from "react";
import { connect, useSelector } from "react-redux";
import i18n from "../../i18n";
import { TRANSLATION_CONST } from "../../_redux/_constants";
import { changeLanguage } from "i18next";

export default function UiLanguageFonts(props) {
  const { lang } = useSelector((state) => {
    return {
      lang: state.lang,
    };
  });

  useEffect(() => {
    changeLanguage(lang?.defaultLang);
  }, [lang?.defaultLang]);

  return (
    <div
      className={
        TRANSLATION_CONST && i18n.language === TRANSLATION_CONST?.TAMIL?.lan
          ? "df-tamil-main-wrapper"
          : TRANSLATION_CONST &&
              i18n.language === TRANSLATION_CONST?.SINHALA?.lan
            ? "df-sinhala-main-wrapper"
            : ""
      }
    >
      {props.children}
    </div>
  );
}
